import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const en = require('../../public/i18n/en.json')
const fr = require('../../public/i18n/fr.json')
const de = require('../../public/i18n/de.json')
const pt = require('../../public/i18n/pt.json')
const pl = require('../../public/i18n/pl.json')
const nl = require('../../public/i18n/nl.json')
const uk = require('../../public/i18n/uk.json')
const es = require('../../public/i18n/es.json')
const ru = require('../../public/i18n/ru.json')

const messages = {
  en,
  fr,
  de,
  pt,
  pl,
  nl,
  uk,
  es,
  ru
}

const i18n = new VueI18n({
  locale:  navigator.language.slice(0, 2), // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages

})

export default i18n
